import tippy from "tippy.js";
import { CSRF, getData, getElement } from "../../../../helpers";
import { Dt } from "../../../../plugins/datatable";
import { CustomerModal as Customer } from "./modals/store";

class CustomerModule extends HTMLElement {
    connectedCallback() {
        this.load();
    }

    load() {
        // console.log(this);
        const DtElement = getElement("[data-table=dt]", this);

        // Start DataTable
        let configDt = {
            processing: true, // Procesar ajax
            serverSide: true, // Mejorar velocidad ajax registros por página
            // Crear cuerpo scrolleable
            scrollY: "500px", // Define la altura de desplazamiento para el cuerpo de la tabla
            scrollCollapse: true, // Permite que el contenido colapse dentro del área definida
            fixedHeader: true, // Mantiene el encabezado visible al hacer scroll
        };

        configDt.ajax = {
            url: getData("customersUrlDt"),
            type: "POST",
            beforeSend: function (request) {
                request.setRequestHeader("X-CSRF-TOKEN", CSRF);
            },
        };
        // Columnas del AJAX
        configDt.columns = [
            { data: "DT_RowIndex", width: "3%", className: "text-center" },
            {
                data: "logo",
                width: "5%",
                className: "text-center",
                orderable: false,
            },
            { data: "name" },
            { data: "cif", width: "7%", className: "text-center" },
            {
                data: "equivalence",
                width: "5%",
                className: "text-center",
                orderable: false,
                // render: (data, type, row, meta) => {
                //     return data;
                // },
            },
            {
                data: "contact",
                width: "10%",
                className: "text-center",
                orderable: false,
            },
            {
                data: "status",
                width: "5%",
                className: "text-center",
                orderable: false,
            },
            {
                data: "buttons",
                width: "5%",
                className: "text-center",
                orderable: false,
            },
        ];

        configDt.drawCallback = () => {
            tippy(".tippy-tooltips");
        };

        const DtCustomers = new Dt(configDt);
        DtCustomers.dataTable(DtElement);
        // End DataTable

        // Eventos
        DtElement.addEventListener("click", (e) => {
            const Target = e.target.closest(".target");

            if (Target) {
                if (Target.classList.contains("edit")) {
                    Customer.edit(
                        getData(Target, "data-bs-target"),
                        getData(Target, "title"),
                        getData(Target, "data-url"),
                        getData(Target, "data-data")
                    );
                }
            }
        });
    }
}

window.customElements.define("customer-module", CustomerModule, {
    extends: "section",
});
